(ns manage.ad-variant-preview.variant-drawer
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Checkbox$default" :as Checkbox]
            ["@mui/material/CircularProgress$default" :as CircularProgress]
            ["@mui/material/ClickAwayListener$default" :as ClickAwayListener]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Paper$default" :as Paper]
            ["@mui/material/Popper$default" :as Popper]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/TextField$default" :as TextField]
            ["@mui/material/ToggleButton$default" :as ToggleButton]
            ["@mui/material/ToggleButtonGroup$default" :as ToggleButtonGroup]
            ["@mui/material/Typography$default" :as Typography]
            ["@mui/x-tree-view/RichTreeView" :refer [RichTreeView]]
            ["@mui/x-tree-view/TreeItem" :refer [TreeItem]]
            ["@mui/x-tree-view/hooks" :refer [useTreeItemUtils useRichTreeViewApiRef]]
            ["src/svg/arrows/arrow-left.svg$default" :as ArrowLeft]
            ["src/svg/arrows/arrow-right.svg$default" :as ArrowRight]
            ["src/svg/controls/filter.svg$default" :as Filter]
            ["src/svg/controls/zoom.svg$default" :as Zoom]
            ["src/svg/inform/cross.svg$default" :as Cross]
            [cljs-bean.core :refer [->clj ->js]]
            [clojure.set :as set]
            [common.patterns.loading-view :refer [loading-view]]
            [common.queries :refer [use-query]]
            [common.resource.query.user :as user.q]
            [common.util :refer [spread-obj spread-props]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.resize :as resize]
            [manage.ad-variant-preview.data :as data]
            [manage.ad-variant-preview.db :as db]
            [manage.ad-variant-preview.hooks :as hooks]
            [manage.ad-variant.queries :as q]
            [manage.ad-variant.widgets :as variant-widgets]
            [mate.core :as mc]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]
            [uix.core :as uix :refer [$ defhook defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui filter-toggle [{:keys [type options filters set-filters]}]
  (let [value (get filters type)]
    ($ form-field
       {:label (data/get-filter-type-title type)}
       ($ ToggleButtonGroup
          {:value (first value)
           :exclusive true
           :onChange (fn [_e filter]
                       (set-filters #(assoc % type (if filter #{filter} #{}))))
           :sx #js {:width "100%"
                    :height "40px"}}
          ($ ToggleButton
             {:value nil
              :sx #js {:flex 1}}
             "All")
          (for [option options]
            ($ ToggleButton
               {:key (:title option)
                :value (:value option)
                :sx #js {:flex 1}}
               (:title option)))))))

(defui filter-checkbox-group [{:keys [type options filters set-filters]}]
  (let [value (get filters type)
        toggle-filter (fn [filters filter-value]
                        (if (contains? filters filter-value)
                          (disj filters filter-value)
                          (conj filters filter-value)))]
    ($ form-field
       {:label (data/get-filter-type-title type)}
       ($ Stack {:gap 0.5}
          (for [option options]
            ($ Stack
               {:key option
                :direction "row"
                :gap 1
                :sx #js {:px 1
                         :py 0.75}}
               ($ Checkbox
                  {:checked (contains? value (:value option))
                   :onChange (fn [_e]
                               (set-filters #(update % type toggle-filter (:value option))))
                   :sx #js {:padding 0}})
               (:title option)))))))

(defui filter-menu [{:keys [filter-options filters set-filters]}]
  (let [[anchor-el set-anchor-el] (uix/use-state nil)
        open (boolean anchor-el)

        [temp-filters set-temp-filters] (uix/use-state filters)

        grouped-filter-options (mc/group-by :type filter-options)
        resolution-filter-options (:resolution grouped-filter-options)

        filter-count (->> (dissoc filters :search)
                          vals
                          (map count)
                          (reduce +))]
    (uix/use-effect (fn []
                      (set-temp-filters filters))
                    [filters])
    ($ :<>
       ($ Button
          {:variant "outlined"
           :color "grey"
           :onClick #(set-anchor-el (fn [anchor-el]
                                      (if anchor-el
                                        nil
                                        (.-currentTarget %))))
           :startIcon ($ Filter)
           :sx (spread-obj #js {:borderColor "grey.50"
                                :color "grey.10"
                                "&:hover" #js {:backgroundColor "grey.80"
                                               :borderColor "grey.30"}}
                           (when open
                             #js {:backgroundColor "grey.70"
                                  :borderColor "grey.20"
                                  :color "grey.100"}))}
          (str "Filters"
               (when (pos? filter-count)
                 (str " (" filter-count ")"))))
       ($ Popper
          {:anchorEl anchor-el
           :open open
           :placement "bottom-start"
           :sx #js {:zIndex 1300}}
          ($ ClickAwayListener
             {:onClickAway #(set-anchor-el nil)}
             ($ Paper
                {:elevation 2
                 :sx #js {:minWidth "282px"}}
                ($ Stack
                   {:gap 1.5
                    :sx #js {:padding 2}}
                   (when (seq resolution-filter-options)
                     ($ filter-toggle
                        {:type :resolution
                         :options resolution-filter-options
                         :filters temp-filters
                         :set-filters set-temp-filters}))
                   (for [[type filter-options] (dissoc grouped-filter-options :resolution)]
                     ($ filter-checkbox-group
                        {:key type
                         :type type
                         :options filter-options
                         :filters temp-filters
                         :set-filters set-temp-filters})))
                ($ Stack
                   {:direction "row"
                    :justifyContent "flex-end"
                    :gap 0.5
                    :sx #js {:padding 1}}
                   ($ Button
                      {:variant "text"
                       :color "grey"
                       :onClick (fn []
                                  (set-temp-filters filters)
                                  (set-anchor-el nil))}
                      "Cancel")
                   ($ Button
                      {:onClick (fn []
                                  (set-filters temp-filters)
                                  (set-anchor-el nil))}
                      "Apply"))))))))

(defui variants-filters [{:keys [filters set-filters
                                 variants all-variants visible-selection
                                 mode is-fetching-variants]}]
  (let [{:keys [adset-id]} (use-subscribe [:url-context])

        {review :data} (use-query (q/review-query {:adset-id adset-id}))
        {me :data} (use-query (user.q/user-query))
        review-mode? (:review (use-subscribe [:router/query-parameters]))
        user-is-reviewer (seq (filter #(= (:id me) (:user-request-mapping/user-id %)) (:user-mappings review)))
        count-in-review (uix/use-memo (fn []
                                        (->> all-variants
                                             (filter (fn [{:keys [approval]}]
                                                       (= "internal-review" approval)))
                                             count))
                                      [all-variants])

        visible-variants (data/get-selected-variants variants visible-selection)
        gallery? (= "gallery" mode)
        index (::data/i (first visible-variants))
        is-first (nil? (::data/prev (first visible-variants)))
        is-last (nil? (::data/next (first visible-variants)))

        filter-options (hooks/use-filter-options {:variants all-variants
                                                  :user-is-reviewer? user-is-reviewer
                                                  :review-mode? review-mode?})]
    ($ :<>
       ($ Stack
          {:direction "column"
           :spacing 1}
          (when user-is-reviewer
            ($ ToggleButtonGroup
               {:value (boolean review-mode?)
                :size "small"
                :exclusive true
                :onChange (fn [_e value]
                            (rfe/set-query #(assoc % :review value))
                            (set-filters #(assoc % :status (if value #{"internal-review"} #{}))))}
               ($ ToggleButton
                  {:value false
                   :sx #js {:flex 1}}
                  "All variants")
               ($ ToggleButton
                  {:value true
                   :sx #js {:flex 1}}
                  (str "In review " (when (pos? count-in-review) (str "(" count-in-review ")"))))))
          ($ TextField
             {:placeholder "Search variants"
              :size "small"
              :fullWidth true
              :value (:search filters)
              :InputProps #js {:endAdornment (if (seq (:search filters))
                                               ($ IconButton
                                                  {:onClick (fn [_e] (set-filters #(assoc % :search "")))
                                                   :edge "end"}
                                                  ($ SvgIcon {:component Cross}))
                                               ;; Match IconButton icon size
                                               ($ SvgIcon {:component Zoom}))}
              ;; TODO: Do we need small debounce?
              :onChange (fn [e] (set-filters #(assoc % :search (.. e -target -value))))}))
       ($ Stack
          {:direction "row"
           :spacing 2
           :alignItems "center"}
          ($ filter-menu
             {:filter-options filter-options
              :filters filters
              :set-filters set-filters})
          ($ Typography
             {:flex 1
              :sx #js {:textAlign "right"}}
             ($ Typography
                {:component "span"
                 :sx #js {:color "grey.40"}}
                "Displaying ")
             ($ Typography
                {:component "span" :noWrap true}
                ($ :span
                   (if gallery?
                     (or index 0)
                     (count visible-variants)))
                (when-not is-fetching-variants
                  ($ Typography
                     {:component "span"
                      :sx #js {:color "grey.40"}}
                     " / "
                     ;; Indices are against the filtered variants on gallery mode so makes sense to show that number
                     (count variants)))))
          (when is-fetching-variants
            ($ CircularProgress {:size 20})))
       (when (= "gallery" mode)
         ($ Stack
            {:direction "row"
             :spacing 1}
            ($ Button
               {:onClick (fn [_e]
                           (let [uuid (::data/prev (first visible-variants))]
                             (rf/dispatch [::db/set-visible-item uuid])))
                :disabled is-first
                :variant "contained"
                :color "grey"
                :sx #js {:width "50%"}
                :startIcon ($ ArrowLeft)}
               "Previous")
            ($ Button
               {:onClick (fn [_e]
                           (let [uuid (::data/next (first visible-variants))]
                             (rf/dispatch [::db/set-visible-item uuid])))
                :disabled is-last
                :variant "contained"
                :color "grey"
                :sx #js {:width "50%"}
                :endIcon ($ ArrowRight)}
               "Next"))))))

(def root-tree-item {:id "root" :label "Ad variants"})

(def CustomTreeItemLabel
  (uix/as-react
   (fn [{:keys [children variant sx]}]
     (if-let [variant (->clj variant)]
       ($ variant-widgets/ad-variant-type-info {:ad-variant variant :sx sx})
       ($ Typography {:component "span" :noWrap true :sx sx} children)))))

(defhook use-checkbox-props [childrenIds visibleSelection]
  (let [selected-map (zipmap childrenIds (map #(contains? visibleSelection %) childrenIds))
        checked (every? true? (vals selected-map))
        indeterminate (and (not checked) (some true? (vals selected-map)))]
    (spread-props #js {}
                  (when (seq childrenIds)
                    #js {:onChange nil
                         :onClick (fn [e]
                                    (.stopPropagation e)
                                    (if indeterminate
                                      (rf/dispatch [::db/set-visible (set/union visibleSelection childrenIds)])
                                      (rf/dispatch [::db/toggle-visible childrenIds])))
                         :checked checked
                         :indeterminate indeterminate}))))

(defn CustomTreeItem [^js props]
  (let [{:keys [itemId visibleSelection checkboxSelection children] :as props*} (->clj props)
        tree-item-utils (useTreeItemUtils {:itemId itemId :children children})
        item (.. tree-item-utils -publicAPI (getItem itemId))
        childrenIds (->> (:children (->clj item))
                         (mapcat #(if (:children %)
                                    (:children %)
                                    [%]))
                         (map :id)
                         set)]
    ($ TreeItem
       ;; `props*` needs to be converted back after `dissoc`,
       ;; otherwise the checkbox click handler will not fire on the first click.
       (spread-props (->js (dissoc props* :visibleSelection :checkboxSelection))
                     {:slots #js {:label CustomTreeItemLabel}
                      :slotProps #js {:label #js {:variant (.-variant item)
                                                  :sx (when (= itemId (:id root-tree-item))
                                                        #js {:fontWeight 600})}
                                      :checkbox (use-checkbox-props childrenIds visibleSelection)
                                      :content #js {:data-testid (str "variant-tree-item-" (.-id item))}}
                      :sx (spread-obj #js {".MuiCollapse-root" #js {:pl 3}}
                                      (when checkboxSelection
                                        #js {".MuiTreeItem-content[data-selected]" #js {:backgroundColor "unset"}}))}))))

(defn variant->tree-item [variant]
  {:id (:uuid variant)
   ;; Label is required by MUI, but we don't use it for child items.
   :label (:content-id variant)
   :variant variant})

(defui variants-list
  "Render virtualized list for the sidebar"
  [{:keys [variants visible-selection]}]
  (let [mode (use-subscribe [::db/mode])
        api-ref (useRichTreeViewApiRef)
        checkbox-selection? (not= "gallery" mode)
        items (uix/use-memo (fn []
                              (->> variants
                                   (mc/group-by :content-id)
                                   (map (fn [[content-id variants]]
                                          {:id content-id
                                           :label content-id
                                           :children (->> variants
                                                          (map variant->tree-item)
                                                          ->js)}))
                                   (sort-by :label)
                                   (assoc root-tree-item :children)
                                   (conj [])
                                   ->js))
                            [variants])
        uuid->variant (uix/use-memo (fn []
                                      (mc/index-by :uuid variants))
                                    [variants])
        all-content-ids (uix/use-memo (fn []
                                        (set (map :content-id variants)))
                                      [variants])
        [expanded set-expanded] (uix/use-state (conj all-content-ids (:id root-tree-item)))]

    ;; Expand parent and root if a child became selected in gallery mode
    (uix/use-effect (fn []
                      (when (= "gallery" mode)
                        (let [selected-uuid (first visible-selection)
                              content-id (-> selected-uuid uuid->variant :content-id)]
                          (set-expanded #(conj % (:id root-tree-item) content-id)))))
                    [mode visible-selection uuid->variant])

    ($ RichTreeView
       {:apiRef api-ref
        :items items
        :multiSelect true
        :checkboxSelection checkbox-selection?

        :expandedItems (to-array expanded)
        :onExpandedItemsChange (fn [_e items]
                                 (let [to-expand (as-> (set items) items
                                                       (if (contains? items (:id root-tree-item))
                                                         items
                                                         #{}))]
                                   (set-expanded to-expand)))

        :selectedItems (->js visible-selection)
        :onSelectedItemsChange (fn [_e ids]
                                 (if (= "gallery" mode)
                                   (when (contains? (set (map :uuid variants)) (first ids))
                                     (rf/dispatch [::db/set-visible-item (first ids)]))
                                   (rf/dispatch [::db/set-visible ids])))

        :slots #js {:item CustomTreeItem}
        :slotProps #js {:item #js {:checkboxSelection checkbox-selection?
                                   :visibleSelection visible-selection}}
        :sx #js {:overflow "hidden auto"}})))

(defui ^:memo drawer-content [{:keys [is-fetching-variants
                                      visible-selection
                                      all-variants
                                      filtered-variants
                                      filters set-filters
                                      mode]}]
  (let [;; Could also pre-process the variants list for faster search,
        ;; e.g. lower-case content-id for search.
        variants (uix/use-memo (fn []
                                 (data/list-variants filtered-variants))
                               [filtered-variants])]
    ($ Stack
       {:gap 2
        :sx #js {:flex 1
                 :p 2
                 :overflow "hidden"}}
       ($ variants-filters
          {:filters filters
           :set-filters set-filters
           :variants variants
           :all-variants all-variants
           :visible-selection visible-selection
           :mode mode
           :is-fetching-variants is-fetching-variants})
       (if (and is-fetching-variants (empty? variants))
         ($ loading-view
            ($ :span "Loading variants..."))
         ($ variants-list
            {:variants variants
             :visible-selection visible-selection})))))

;; Because content component has e.g.
;; viewport position as hook state, it is rendered
;; often so its children are also rendered often.
;; It is better if the drawer is only rendered when
;; the props change.
(defui ^:memo drawer [{:keys [is-fetching-variants
                              visible-selection
                              all-variants
                              filtered-variants
                              filters set-filters
                              mode]}]
  (let [[width set-width] (resize/use-drawer-width {:k "ad-variant-preview-left"})]
    ($ Paper
       {:sx #js {:mb 0.5
                 :display "flex"
                 :position "relative"
                 :maxWidth "50%"
                 :overflow "hidden"
                 :width width}}
       ($ drawer-content
          {:is-fetching-variants is-fetching-variants
           :visible-selection visible-selection
           :all-variants all-variants
           :filtered-variants filtered-variants
           :filters filters
           :set-filters set-filters
           :mode mode})

       ($ resize/resize-handle
          {:width width
           :set-width set-width
           :calculate-width resize/left-side-width
           ;; Place the resize handle over the sidebar border
           :sx #js {:right 0}
           :border-sx #js {:right 0}}))))
